import React from 'react';
import PropTypes from 'prop-types';
import BrandfolderLogoHoriz from '@assets/images/Brandfolder_logo.png';

import './styles/footer.scss';

const Footer = (props) => (
  <div className="footer-component">
    <div className="footer-component__left">
      <div className="copyright-container">
        <p className="copyright-text">
          ©{(new Date()).getFullYear()} {props.copyright}
          <span className="dot">·</span>
        </p>
      </div>
      <div className="links-container">
        <a
          href={props.privacy_policy}
          target="_blank"
          rel="noopener noreferrer"
        >
          {bfTranslate('Privacy Policy')}
        </a>
        <span className="dot">·</span>
        <a
          href={props.terms_of_service}
          target="_blank"
          rel="noopener noreferrer"
        >
          {bfTranslate('Terms of Service')}
        </a>
      </div>
    </div>
    <div className="footer-component__right">
      <a
        className="bf-logo-container"
        href="https://brandfolder.com/home"
        target="_blank"
        rel="noopener noreferrer"
      >
        <span>{bfTranslate('Powered by')}</span>
        <img className="bf-logo-horiz" src={BrandfolderLogoHoriz} alt="branfolder logo" />
      </a>
    </div>
  </div>
);

Footer.propTypes = {
  copyright: PropTypes.string.isRequired,
  privacy_policy: PropTypes.string.isRequired,
  terms_of_service: PropTypes.string.isRequired
};

export default Footer;
